import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { Divider } from '@usepepper/ui/atoms/divider';
import { View } from 'react-native';

const ROW_COUNT = 5;
const BASE_COLUMN_COUNT = 5;
const ROW_HEIGHT = 32;
const BASE_COLUMN_WIDTH = 120;

export const OrderEntryTableSkeleton = () => {
  const [styles] = useStyles();

  return (
    <View accessibilityState={{ busy: true }} style={styles.container}>
      <View style={styles.header}>
        <View style={styles.stickyColumns}>
          <View collapsable={false} style={styles.quantityColumn} />
          <View style={styles.nameHeaderColumn}>
            <AnimatedSkeletonLoader height={12} width={24} />
          </View>
        </View>
        {Array.from({ length: BASE_COLUMN_COUNT }).map((_, headerIndex) => (
          <View key={headerIndex} style={styles.baseHeaderColumn}>
            <AnimatedSkeletonLoader height={12} width={24} />
          </View>
        ))}
      </View>
      <Divider />
      <View style={styles.body}>
        {Array.from({ length: ROW_COUNT }).map((_, rowIndex) => (
          <View key={rowIndex} style={{ opacity: 1 - rowIndex * 0.2 }}>
            <View style={styles.row}>
              <View style={styles.stickyColumns}>
                <View style={styles.quantityColumn}>
                  <AnimatedSkeletonLoader
                    borderRadius={8}
                    height={32}
                    width={48}
                  />
                </View>
                <View style={styles.nameColumn}>
                  <AnimatedSkeletonLoader
                    borderRadius={8}
                    height={32}
                    width={32}
                  />
                  <AnimatedSkeletonLoader
                    borderRadius={8}
                    height={14}
                    width={102}
                  />
                </View>
              </View>
              {Array.from({ length: BASE_COLUMN_COUNT }).map((_, colIndex) => (
                <View key={colIndex} style={styles.baseColumn}>
                  <AnimatedSkeletonLoader height={14} width={62} />
                </View>
              ))}
            </View>
            <Divider key={rowIndex} />
          </View>
        ))}
      </View>
    </View>
  );
};

const useStyles = createStyles(() => ({
  baseColumn: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    minWidth: BASE_COLUMN_WIDTH,
  },
  baseHeaderColumn: {
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    minWidth: BASE_COLUMN_WIDTH,
  },
  body: {
    flexDirection: 'column',
  },
  container: {
    paddingHorizontal: 24,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: ROW_HEIGHT,
    paddingBottom: 12,
  },
  nameColumn: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 12,
    justifyContent: 'flex-start',
    minWidth: 2 * BASE_COLUMN_WIDTH, // double size column
  },
  nameHeaderColumn: {
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    minWidth: 2 * BASE_COLUMN_WIDTH, // double size column
  },
  quantityColumn: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    minWidth: 48,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: ROW_HEIGHT,
    paddingVertical: 8,
  },
  stickyColumns: {
    flexDirection: 'row',
    gap: 16,
  },
}));
